import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { StyledImgDivContainerProps } from '../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../shared/aws/awsHelper';
import OptimizedMoleculeImgDivContainer from '../../shared/component/molecule/OptimizedMoleculeImgDivContainer';
import { ProjectSimpleData } from '../../shared/dto/EntityRepository';
import ProjectEditController from './ProjectEditController';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';


interface ProjectSimpleCardProps {
  data: ProjectSimpleData;
}

const ProjectSimpleCard: React.FC<ProjectSimpleCardProps> = ({ data }) => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { isEditMode } = useEditMode();
  const projectDetailPath = pageOwner ? `/@${pageOwner.handle}/projects/${data.id}` : '#';

  const handleProjectLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isEditMode || !pageOwner) {
      e.preventDefault();
    }
  }

  return (
    <ProjectSimpleComp>
      <ContentWrapper to={projectDetailPath} onClick={handleProjectLinkClick} $isPublic={data.isPublic}>
        <ProjectSimpleInfo>
          <ProjectSimpleTitle><ProjectSimpleYear>{data.projectYear ? data.projectYear : ''}</ProjectSimpleYear>{data.title}</ProjectSimpleTitle>
        </ProjectSimpleInfo>
        <OptimizedMoleculeImgDivContainer
          backgroundImg={convertS3UrlToCloudFrontUrl(data.originUrl)}
          StyledImgDivContainer={ProjectRepresent}
          $focusX={data.focusX ?? 0.5}
          $focusY={data.focusY ?? 0.5}
        />
      </ContentWrapper>
      <ProjectEditController
        projectId={data.id}
        isPublic={data.isPublic}
      />
    </ProjectSimpleComp>
  );
};

const ProjectSimpleComp = styled.div`
  position: relative;

  width: 100%;
  height: calc(130vw / 4);
  display: flex;
  justify-content: space-between; 
  margin-bottom: 20px;
  cursor: pointer;
`;

const ContentWrapper = styled(Link)<{ $isPublic: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
  ${({ $isPublic }) => !$isPublic && `
    opacity: 0.6;
  `}
`;

const ProjectSimpleInfo = styled.div`
  width: calc(40vw);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0px 10px;
  padding-bottom: 2px;
`;

const ProjectSimpleYear = styled.span`
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
  font-style: italic;
`;

const ProjectSimpleTitle = styled.h2`
  text-align: end;
  ${({ theme }) => theme.typography.Body_00_1};
`;

const ProjectRepresent = styled.div<StyledImgDivContainerProps & {
  $focusX: number;
  $focusY: number;
}>`
  width: calc(60vw);
  height: 100%;

  background-image: url(${props => props.$backgroundImg});
  background-size: cover;
  background-position: ${({ $focusX, $focusY }) => `${$focusX * 100}% ${$focusY * 100}%`};
  position: relative;
`;


export default ProjectSimpleCard;
